// Parseo del token @[Label](tipo:id) que arma el picker de @ en el composer
// y guarda MessagesController::parseMentions() en el backend. Un solo lugar
// para esta regex: componentes de mensajes y el composer la comparten en
// vez de reimplementarla cada uno por su lado.
const MENTION_TOKEN_REGEX = /@\[([^\]]+)\]\((\w+):(\d+)\)/g

// Parte un body en segmentos {type:'text'} / {type:'mention'} para renderizar
// texto normal intercalado con chips, en el orden en que aparecen.
export function parseMentionParts(body) {
  const text = body || ''
  const parts = []
  let lastIndex = 0
  let match

  MENTION_TOKEN_REGEX.lastIndex = 0
  while ((match = MENTION_TOKEN_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: text.slice(lastIndex, match.index) })
    }
    parts.push({
      type: 'mention',
      label: match[1],
      mentionType: match[2],
      mentionId: match[3],
    })
    lastIndex = MENTION_TOKEN_REGEX.lastIndex
  }
  if (lastIndex < text.length) {
    parts.push({ type: 'text', value: text.slice(lastIndex) })
  }
  if (!parts.length) parts.push({ type: 'text', value: text })
  return parts
}

// Arma el token a insertar en el textarea cuando se elige un resultado del
// picker de @.
export function buildMentionToken(label, type, id) {
  return '@[' + label + '](' + type + ':' + id + ')'
}
